import React from "react"
import { generatePath } from "react-router-dom"
import * as routes from "../../../../../library/constants/routes"
import { meanBy, sumBy } from "lodash"
import { minutesToString } from "../../../../../library/utils/timeConvert"
import { getUserName } from "../../../../../library/utils/user/userUtils"
import InfoTable from "../../../../../components/v2/utils/infoTable"
import { getSubjectName } from "../../../../../library/utils/educational"

const KnowmixDetails = ({ knowmix }) => {
  const creatorName = knowmix.creator_user
    ? `${knowmix.creator_user?.first_name} ${knowmix.creator_user?.last_name}`
    : knowmix.creator_group?.name

  const creatorUrl = knowmix.creator_user
    ? generatePath(routes.USER, { userId: knowmix.creator_user?.id })
    : generatePath(routes.GROUP, { groupId: knowmix.creator_group?.id })

  const averageStepsTime = Math.round(
    meanBy(knowmix.steps, (step) => step.time)
  )
  const totalStepsTime = sumBy(knowmix.steps, (step) => step.time)

  return (
    <div className="box__content">
      <InfoTable
        data={[
          {
            label: "Name",
            text: knowmix.name,
          },
          {
            label: "Creator",
            link: {
              to: creatorUrl,
              text: creatorName,
            },
          },
          {
            label: "Subject",
            text: getSubjectName(knowmix.subject),
          },
          {
            label: "Info",
            text: knowmix.instructions,
          },
          {
            label: "Goal",
            text: knowmix.goal,
          },
          (knowmix.is_teacher || knowmix.is_admin) && {
            label: "Measurement",
            text: knowmix.measurement,
          },
          !!knowmix?.links?.length && {
            label: "Links",
            linkTitleKey: "title",
            links: knowmix.links,
            newTab: true,
            external: true,
          },
          !!knowmix?.blobs?.length && {
            label: "Attachments",
            files: knowmix.blobs,
          },
          !!knowmix.steps.length && {
            label: "Number of steps",
            text: knowmix.steps.length,
          },
          !!knowmix.steps.length &&
            !!averageStepsTime && {
              label: "Average time to complete each step",
              text: minutesToString(averageStepsTime),
            },
          !!knowmix.steps.length &&
            !!totalStepsTime && {
              label: "Total study time",
              text: minutesToString(totalStepsTime),
            },
          !!knowmix.teacher && {
            label: "Teacher",
            link: {
              to: generatePath(routes.USER, {
                userId: knowmix.teacher?.id,
              }),
              text: getUserName(knowmix.teacher),
            },
          },
        ]}
      />
    </div>
  )
}

export default KnowmixDetails
